import React from 'react';
import { motion } from 'framer-motion';

const GradientIcon = ({ Icon, size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-10 h-10 sm:w-12 sm:h-12',
    md: 'w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16',
    lg: 'w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24'
  };

  const iconSizes = {
    sm: 'w-5 h-5 sm:w-6 sm:h-6',
    md: 'w-6 h-6 sm:w-7 sm:h-7 lg:w-8 lg:h-8',
    lg: 'w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12'
  };

  return (
    <div className="relative inline-block">
      {/* Glow effect layer */}
      <div className={`absolute inset-0 bg-gradient-to-br from-violet-600 to-pink-600 ${sizeClasses[size]} rounded-full blur-xl opacity-40`}></div>

      {/* Icon container */}
      <motion.div
        className={`relative inline-flex items-center justify-center ${sizeClasses[size]} bg-gradient-to-br from-violet-600 to-pink-600 rounded-full shadow-xl ${className}`}
        whileHover={{ scale: 1.05, rotate: 5 }}
        whileTap={{ scale: 0.95 }}
        animate={{
          boxShadow: [
            '0 10px 25px rgba(147, 51, 234, 0.3)',
            '0 10px 35px rgba(236, 72, 153, 0.4)',
            '0 10px 25px rgba(147, 51, 234, 0.3)',
          ]
        }}
        transition={{
          boxShadow: { duration: 2, repeat: Infinity, ease: "easeInOut" }
        }}
      >
        <Icon className={`${iconSizes[size]} text-white`} />
      </motion.div>
    </div>
  );
};

export default GradientIcon;
